var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.obj_to_null(this.product)
    ? _c(
        "div",
        { staticClass: "prod_info" },
        [
          this.product.hasOwnProperty("main_photo")
            ? _c("div", { staticClass: "text-center" }, [
                _c("picture", [
                  _c("source", {
                    attrs: {
                      srcset: _vm.product.main_photo.webp,
                      type: "image/webp",
                    },
                  }),
                  _vm._v(" "),
                  _c("source", {
                    attrs: {
                      srcset: _vm.product.main_photo.jpeg,
                      type: "image/jpeg",
                    },
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticStyle: { "max-width": "350px" },
                    attrs: {
                      itemprop: "image",
                      src: _vm.product.main_photo.jpeg,
                    },
                  }),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "ct",
              f_type: "title",
              f_title: _vm.__t("NAME"),
              is_disabled: _vm.is_disabled,
              f_val: _vm.product.title,
            },
            on: { update_categ: _vm.change_atr },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form-group mt-2" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "description" } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.__t("INTRO_PROD")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input-group flex-nowrap" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.product.content,
                    expression: "product.content",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "description", type: "text" },
                domProps: { value: _vm.product.content },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.product, "content", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pt-2 pb-2" }, [
            _c("h5", { staticClass: "frame-heading" }, [
              _vm._v(_vm._s(_vm.__t("CATEG_TAG_PUBLISH"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "custom-control custom-checkbox custom-control-inline",
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.product.published,
                      expression: "product.published",
                    },
                  ],
                  staticClass: "custom-control-input",
                  attrs: { type: "checkbox", id: "publish" },
                  domProps: {
                    checked: Array.isArray(_vm.product.published)
                      ? _vm._i(_vm.product.published, null) > -1
                      : _vm.product.published,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.product.published,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.product,
                              "published",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.product,
                              "published",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.product, "published", $$c)
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "custom-control-label",
                    attrs: { for: "publish" },
                  },
                  [_vm._v(_vm._s(_vm.__t("PUBLISHED_TTL")))]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cid",
              f_title: _vm.__t("UNIQ_PROV_CODE"),
              f_val: _vm.product.uniq_id.toString(),
            },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cuid",
              f_title: _vm.__t("UNIQ_GO_CODE"),
              f_val: _vm.product.id,
            },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cuid",
              f_title: _vm.__t("GO_PROD_TYPE"),
              f_val: _vm.product.go_type,
            },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_title: _vm.__t("LOAD_FROM"),
              f_icon: "fa-sync",
              f_val: _vm.prov_name,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }